import { useState } from 'react';
import JsonView from 'react18-json-view';
import 'react18-json-view/src/style.css';
import { PillButtons } from '../input';
import { styles } from '../../constants';

export const RawResults = ({ results }) => {
  const [tab, setTab] = useState('pretty');

  const choices = [
    ['pretty', 'Formatted'],
    ['text', 'Plain'],
  ];

  return (
    <div>
      <PillButtons value={tab} onChange={setTab} choices={choices} />

      <div style={{ marginTop: 10, fontSize: 12, maxWidth: 800, overflow: 'scroll' }}>
        {tab == 'pretty' && (
          <div>
            <JsonView src={results} />
          </div>
        )}
        {tab == 'text' && <pre style={styles.pre}>{JSON.stringify(results, null, 2)}</pre>}
      </div>
    </div>
  );
};
